import { render, staticRenderFns } from "./ConnectionInfo.vue?vue&type=template&id=0ef1bf4d&"
import script from "./ConnectionInfo.vue?vue&type=script&lang=ts&"
export * from "./ConnectionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ConnectionInfo.vue?vue&type=style&index=0&id=0ef1bf4d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports